export const POSTER_SESSION_SETTINGS = 'POSTER_SESSION_SETTINGS';

export const SessionSettings = {
  BATCH_CREATION_CART_SORTS: 'batch_creation_cart_sorts',
};
